<template lang="html">
  <div class="advance-select position-relative">
    <button type="button" class="btn-label btn btn-link-action"
      @click="toggleDropdown()">
      {{ label }} <i class="fas fa-angle-up"></i>
    </button>
    <dropdown-container :open="open" @cancel="cancelDropdown">
      <div class="h-100 position-relative">
        <!-- Mobile top actions (close & reset) -->
        <div v-if="requiresApply && !deviceMd"
        class="mobile-top-action">
          <button @click="cancelDropdown()"
          class="btn btn-link-action">
            <i class="fal fa-times"></i>
          </button>
          <button @click="resetValues()"
          class="btn btn-link-action">
            reset
          </button>
        </div>

        <!-- Content -->
        <div class="advance-select-content py-ns-2">
          <div v-if="!deviceMd" class="mobile-top-spacer"/>
          <slot>AdvanceSelect controls not loaded.</slot>
          <div v-if="!deviceMd" class="mobile-bottom-spacer"/>
        </div>

        <!-- Non mobile bottom actions (apply & reset) -->
        <div v-if="requiresApply && deviceMd"
        class="d-flex justify-content-between items-align-center">
          <button type="button" class="reset-btn btn btn-link-action"
            @click="resetValues()">
            reset
          </button>
          <button type="button" class="btn btn-action"
            @click="confirmDropdown()">
            apply
          </button>
        </div>

        <!-- Mobile bottom action (apply) -->
        <div v-if="!deviceMd"
        class="mobile-bottom-action position-absolute w-100">
          <button @click="confirmDropdown()"
          class="btn btn-action w-100">
            apply
          </button>
        </div>
      </div>
    </dropdown-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DropdownContainerComponent from '@/components/DropdownContainer';

export default {
  components: {
    'dropdown-container': DropdownContainerComponent
  },
  props: {
    label: {
      type: String,
      required: true,
      default: 'advanceselect'
    },
    requiresApply: {
      type: Boolean,
      default: false
    },
    fillWidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false
    };
  },
  computed: {
    ...mapGetters({
      deviceMd: 'ui/deviceMd'
    })
  },
  methods: {
    toggleDropdown() {
      if (this.open) {
        this.cancelDropdown();
      } else {
        this.open = true;
      }
    },
    cancelDropdown() {
      this.open = false;
      this.$emit('cancel');
    },
    confirmDropdown() {
      this.open = false;
      this.$emit('apply');
    },
    resetValues() {
      this.$emit('reset');
    }
  }
};
</script>

<style lang="scss" scoped>
$mobile-bar-height: 40px;

.advance-select-content {
  overflow-y: auto;
  overflow-x: hidden;
  font-family: Scandia-Regular, sans-serif;
  position: relative;

  @media screen and (max-width: $breakpoint-sm) {
    position: absolute;
    height: 100%;
    width: 100%;
    padding: 1rem;
  }
}

.reset-btn {
  margin-left: -12px;
}

.mobile-top-spacer {
  // height: $mobile-bar-height;
}

.mobile-bottom-spacer {
  height: $mobile-bar-height + $app-bar-height;
}

.mobile-top-action {
  position: relative;
  // top: $app-bar-height-mobile;
  top: 0px;
  height: $mobile-bar-height;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  z-index: 999;

  .fa-times {
    font-size: 1.4rem;
  }
}

.mobile-bottom-action {
  height: $mobile-bar-height;
  bottom: 0;
  z-index: 999;
  display: flex;
  align-items: flex-end;
  padding: 1rem;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Input/AdvanceSelect.vue